export default function ThSorted({awailableColumnsKey, sortTable, setSortTable, awailableColumns}) {
    return (
        <th>
            {sortTable ? (
                <>
                    {awailableColumnsKey === sortTable.sort ? (
                        <span
                            className="cursor-pointer d-flex align-items-center"
                            onClick={() =>
                                setSortTable({
                                    sort: awailableColumnsKey,
                                    sortDirection:
                                        sortTable.sortDirection === "asc"
                                            ? "desc"
                                            : "asc",
                                })
                            }
                        >
                              {awailableColumns[awailableColumnsKey]}
                            {sortTable.sortDirection === "asc" ? (
                                <i className="ki-solid ki-arrow-up fs-4"></i>
                            ) : (
                                <i className="ki-solid ki-arrow-down fs-4"></i>
                            )}
                            </span>
                    ) : (
                        <span
                            className="cursor-pointer"
                            onClick={() =>
                                setSortTable({
                                    sort: awailableColumnsKey,
                                    sortDirection: "desc",
                                })
                            }
                        >
                              {awailableColumns[awailableColumnsKey]}
                            <i className="ki-solid ki-arrow-down fs-4 opacity-0"></i>
                            </span>
                    )}
                </>
            ) : (
                awailableColumns[awailableColumnsKey]
            )}
        </th>
    );
}